import $ from 'jquery';
import 'select2';
import 'Inputmask';
import 'jquery-validation';

// Check boxes
// ------------------------------------------------------------------------ //
const $checkBoxes = $('.form-group.CheckBox');

$checkBoxes.each((i, el) => {
  const $el = $(el);
  const $label = $el.find('label');

  $label.click(e => {
    const $checkBox = $label.find('input[type="checkbox"]');
    // e.preventDefault();
    if ($checkBox.is(':checked')) {
      $el.addClass('is-checked');
    } else {
      $el.removeClass('is-checked');
    }
  });
});

// Fancy Select Boxes
// ------------------------------------------------------------------------ //
$(document).ready(function () {
  $('form.formbuilder select.form-control').each((i, el) => {
    const $el = $(el);

    if ($el.hasClass('form-control-light')) {
      $el.select2({
        language: $('html').attr('select2-lang'),
        containerCssClass: 'form-control-light',
        width: '100%',
        placeholder: $el.attr('placeholder'),
        allowClear: true
      });
    } else {
      $el.select2({
        language: $('html').attr('select2-lang'),
        width: '100%',
        placeholder: $el.attr('placeholder'),
        allowClear: true
      });
    }
  });
})

// Form validation
// ------------------------------------------------------------------------ //
const $formBuilderForms = $('form.formbuilder');

$formBuilderForms.each((i, form) => {
  const $form = $(form);

  $form.validate({
    errorPlacement: (error, element) => {
      error.appendTo(element.parent());
    },
    submitHandler: thisForm => {
      // do other things for a valid form
      thisForm.submit();
    }
  });
});
